import { createClient } from '@supabase/supabase-js'

// IntelliTrack 2.0 Database (Primary - used for auth and profiles)
const intelliTrackUrl = process.env.REACT_APP_SUPABASE_INTELLITRACK_URL!
const intelliTrackAnonKey = process.env.REACT_APP_SUPABASE_INTELLITRACK_ANON_KEY!

export const intelliTrackClient = createClient(intelliTrackUrl, intelliTrackAnonKey, {
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
})

// Default client for authentication (using IntelliTrack database)
export const supabase = intelliTrackClient